import { lazy } from "react";

export const importView = (name) => {
  return lazy(() => import(/* webpackChunkName: "cust-[request]" */ `modules/emp/views/${name}`));
};

export function getMethodColor(val) {
  const colors = {
    GET: "green",
    POST: "orange",
    PUT: "blue",
    DELETE: "red",
  };
  return colors[val];
}
